
// WHY: между перезагрузками не сохранять: серверная разметка про кэш не знает, расхождение сломает гидратацию
const MAX_TRACKED = 300;

const loaded = new Set<string>();

// WHY: ключ — абсолютный адрес: SSR кладёт `/api/users/avatar/<id>`, после гидратации тот же ресурс уже с хостом
function keyOf(src: string): string {
  if (typeof window === 'undefined') return src;
  try {
    return new URL(src, window.location.href).href;
  } catch {
    return src;
  }
}

export function isImageLoaded(src: string | null | undefined): boolean {
  return !!src && loaded.has(keyOf(src));
}

export function markImageLoaded(src: string | null | undefined): void {
  if (!src) return;
  const key = keyOf(src);
  loaded.delete(key);
  loaded.add(key);
  if (loaded.size > MAX_TRACKED) {
    const oldest = loaded.values().next().value;
    if (oldest !== undefined) loaded.delete(oldest);
  }
}

export function forgetImageLoaded(src: string | null | undefined): void {
  if (src) loaded.delete(keyOf(src));
}

export function resetLoadedImages(): void {
  loaded.clear();
}
